import { AuthenticationService } from './../../login/AuthService/auth.service';
import { Component, OnInit } from '@angular/core';
import { Router, Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import decode from 'jwt-decode';
declare var $: any;
declare var jQuery: any;

@Component({
  selector: 'app-layouts',
  templateUrl: './layouts.component.html',
  styleUrls: ['./layouts.component.scss']
})
export class LayoutsComponent implements OnInit {

  constructor(private auth: AuthenticationService, public router: Router) { }

  ngOnInit() { }

  public get authenticated() {
    return this.auth.isAuth();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/layouts/layouts.component.ts